export const screenSize = {
  size_s: '1070px',
  size_m: '1280px',
  size_xl: '1440px',
  size_2xl: '1536px',
  size_3xl: '1920px',
};

export enum Breakpoints {
  sm = '40rem',
  md = '48rem',
  lg = '64rem',
  xl = '80rem',
  '2xl' = '96rem',
}
